import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Product from './components/Product';
import SingleProduct from './components/SingleProduct';
import Layout from './components/Layout';
import AdminAddProduct from './components/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';

function getIsAdminFromToken() {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const payload = JSON.parse(jsonPayload);

    // Kontrollera rollen "Admin"
    return payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'Admin';
  } catch {
    return false;
  }
}

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setIsAdmin(getIsAdminFromToken());
  }, []);

  const handleLogin = () => {
    setIsAdmin(true);
  };

  return (
   <Router>
  <Routes>
    {/* Login route UTAN Layout */}
    <Route path="/login" element={<Login onLogin={handleLogin} />} />

    {/* Alla andra routes MED Layout */}
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="products/:categoryId" element={<Product />} />
      <Route path="product/:productId" element={<SingleProduct />} />
      <Route
        path="admin"
        element={
          <ProtectedRoute isAdmin={isAdmin}>
            <AdminAddProduct />
          </ProtectedRoute>
        }
      />
    </Route>
  </Routes>
</Router>

  );
};

export default App;
